export default "__VITE_ASSET__DfTBxfkB__"